import { render, staticRenderFns } from "./CopyDialog.vue?vue&type=template&id=5daee935&"
import script from "./CopyDialog.vue?vue&type=script&lang=js&"
export * from "./CopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports